import type { Settlement, OrderDetail } from '../types/settlement.types'

export const mockSettlements: Settlement[] = [
    {
        id: 'SET-001',
        merchant: 'ABC Building Supplies',
        ordersCount: 5,
        totalAmount: 75000,
        platformFee: 3750,
        netAmount: 71250,
        status: 'completed',
        scheduledDate: '2024-12-15',
        completedDate: '2024-12-15',
        bankAccount: '****1234',
        ifscCode: 'HDFC0001234',
        utrNumber: 'UTR123456789',
    },
    {
        id: 'SET-002',
        merchant: 'XYZ Materials',
        ordersCount: 3,
        totalAmount: 150000,
        platformFee: 7500,
        netAmount: 142500,
        status: 'pending',
        scheduledDate: '2024-12-25',
        bankAccount: '****5678',
        ifscCode: 'ICIC0005678',
    },
    {
        id: 'SET-003',
        merchant: 'DEF Construction',
        ordersCount: 2,
        totalAmount: 50000,
        platformFee: 2500,
        netAmount: 47500,
        status: 'processing',
        scheduledDate: '2024-12-23',
        bankAccount: '****9012',
        ifscCode: 'SBIN0009012',
    },
]

export const mockOrderDetails: OrderDetail[] = [
    { orderId: 'ORD-001', amount: 15000, date: '2024-12-10' },
    { orderId: 'ORD-002', amount: 25000, date: '2024-12-11' },
    { orderId: 'ORD-003', amount: 20000, date: '2024-12-12' },
    { orderId: 'ORD-004', amount: 10000, date: '2024-12-13' },
    { orderId: 'ORD-005', amount: 5000, date: '2024-12-14' },
]
